<template>
    <div class="about-goals">
        <z-caption
            size="3xl"
            decor-left
            decor-right
            class="about-goals__title sustainability-page__title"
        >
            <span v-html="text.title" />
        </z-caption>
        <div class="about-goals__body">
            <div class="about-goals__content">
                <div class="about-goals__image">
                    <img
                        src="/images/company/about/goals-img.webp"
                        alt="goals"
                    >
                </div>
                <div class="about-goals__indicators">
                    <accordion
                        v-for="(goal, index) in goals"
                        :key="index"
                        :ref="'goalsAccordions'"
                        :id="goal.id"
                        :title="goal.title"
                        :indicator="goal.indicator"
                        :image="goal.image"
                        :image-indicator="goal.imageIndicator"
                        @toggle="switchGoalsAccordions"
                        class="about-goals__indicator"
                    >
                        <p v-html="goal.text" />
                    </accordion>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { localize } from '@/utils/i18n'
import Accordion from './SustainabilityPage/components/Accordion.vue'

export default {
    name: 'about-goals',
    components: { Accordion },
    data () {
        return {
            goals: [
                {
                    id: 'ore',
                    title: localize({
                        ru: 'Рост добычи руды',
                        en: 'Growth in&nbsp;ore production'
                    }),
                    indicator: localize({
                        ru: 'в 1,8 раза',
                        en: '1.8 x'
                    }),
                    text: localize({
                        ru: 'В 1,8 раза',
                        en: '1.8 x'
                    }),
                    image: '/images/company/about/goals-img-1.webp',
                    imageIndicator: localize({
                        ru: '1,8',
                        en: '1.8'
                    })
                },
                {
                    id: 'metal',
                    title: localize({
                        ru: 'Рост производства металлов',
                        en: 'Growth in&nbsp;metals output'
                    }),
                    indicator: localize({
                        ru: 'до 50%',
                        en: 'up to 50%'
                    }),
                    text: localize({
                        ru: 'На&nbsp;20&ndash;30% по&nbsp;никелю и&nbsp;меди,<br />на 40&ndash;50% по&nbsp;МПГ',
                        en: '+20&ndash;30% for nickel and copper,<br />+40&mdash;50% for PGMs'
                    }),
                    image: '/images/company/about/goals-img-2.webp',
                    imageIndicator: localize({
                        ru: '50%',
                        en: '50%'
                    })
                },
                {
                    id: 'sulphur',
                    title: localize({
                        ru: 'Серная Программа 2.0',
                        en: 'Sulphur Project 2.0'
                    }),
                    text: localize({
                        ru: 'Сокращение выбросов диоксида серы в&nbsp;десятки раз',
                        en: 'Cutting sulphur dioxide emissions by&nbsp;an&nbsp;order of&nbsp;magnitude'
                    }),
                    image: '/images/company/about/goals-img-3.webp'
                },
                {
                    id: 'zero',
                    title: localize({
                        ru: 'Отсутствие смертельных случаев на производстве',
                        en: 'Zero fatalities'
                    }),
                    indicator: '0',
                    text: localize({
                        ru: 'Отсутствие смертельных случаев на&nbsp;производстве, исключение аварий с&nbsp;катастрофическими последствиями, стабильное снижение рисков&nbsp;ПБ и&nbsp;ОТ до&nbsp;приемлемого уровня',
                        en: 'Annual reduction in&nbsp;work-related injuries by&nbsp;15%, zero fatalities'
                    }),
                    image: '/images/company/about/goals-img-4.webp',
                    imageIndicator: '0'
                }
            ],
            text: {
                title: localize({
                    ru: 'Цели стратегии до&nbsp;2030&nbsp;года',
                    en: '2030 strategy objectives'
                })
            }
        }
    },
    methods: {
        switchResultsAccordions (currentId) {
            this.$refs.goalsAccordions.forEach(accordion => {
                if (accordion.id !== currentId) accordion.state = false
            })
        },
        switchGoalsAccordions (currentId) {
            this.$refs.goalsAccordions.forEach(accordion => {
                if (accordion.id !== currentId) accordion.state = false
            })
        }
    }
}
</script>

<style lang="scss">
.about-goals {

    &__body {
        margin-top: $token-spacers-2-s;

        @include breakpoint(mobile) {
            margin-top: 0;
        }
    }

    &__content {
        display: flex;
        gap: $token-spacers-s;
    }

    &__image {
        flex: 1;
        max-width: 568px;
        border-radius: 0px 40px 0px 20px;
        overflow: hidden;

        @include breakpoint(tablet) {
            display: none;
        }

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    &__indicators {
        min-width: 760px;
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: $token-spacers-2-xs;

        @include breakpoint(v-tablet) {
            min-width: 0;
        }

        @include breakpoint(mobile) {
            flex-direction: row;
            gap: $token-spacers-3-xs;
            padding: 0 16px;
            margin: 0 -16px;
            overflow-x: auto;
            scroll-snap-type: x mandatory;
            scroll-behavior: smooth;
        }
    }

    &__indicator {
        @include breakpoint(mobile) {
            min-width: 300px;
            // scroll-snap-align: start;
        }
    }
}
</style>
